import { createWrapper } from '../../fhir-react/base';

export const GoalWrapper = createWrapper('Goal', (goal) => ({
  getPathway: () => goal?.category?.[0]?.coding?.[0]?.code,
  getPathwayDisplay: () => goal?.category?.[0]?.text,
  getPlainDescription: () => goal.description.text,
  getPlainAchievementStatus: () => goal?.achievementStatus?.coding?.[0]?.code,
  getEndDate: () => goal?.target?.[0]?.dueDate,
  getComments: () => goal?.note?.[0]?.text,
}));

export type WrappedGoal = ReturnType<typeof GoalWrapper>;
